module.exports = __webpack_public_path__ + "static/media/redBreastedGoose2.70fa04c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/redBreastedGoose2.jpg
// module id = 124
// module chunks = 0